<template>
  <div class="join-page">
    <div class="toolbar">
      <el-button size="small" class="btn btn-back" icon="el-icon-arrow-left" @click="doBack" round>返回</el-button>
    </div>
    <div class="content">
      <h1 class="home-title">创建企业</h1>
      <p class="home-description">我们将在企业中为您提供优质服务</p>
      <hr>
      <div class="new-comp-wrap">
        <el-form :model="fm" ref="registerFm" size="small" center label-width="90px" :rules="rules">
          <el-form-item label="企业名称" prop="name">
            <el-input v-model="fm.name" placeholder="请输入企业名称"></el-input>
          </el-form-item>
          <el-form-item label="所属行业" prop="name">
            <el-select v-model="fm.industry" placeholder="请选择">
              <el-option
                  v-for="item in industry_list"
                  :key="item.id"
                  :label="item.name"
                  :value="item.name">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="企业规模" prop="type">
            <el-select v-model="fm.scale" placeholder="请选择">
              <el-option
                  v-for="item in scale_list"
                  :key="item.id"
                  :label="item.name"
                  :value="item.name">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="联系电话" prop="phone">
            <el-input v-model="fm.phone" placeholder="请输入联系电话"></el-input>
          </el-form-item>
          <el-form-item label="公司地址" prop="address">
            <el-input v-model="fm.address" placeholder="请输入公司地址"></el-input>
          </el-form-item>
          <div class="text-align-center">
            <el-button class="btn-register" type="primary" @click="doRegister">完成创建</el-button>
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { create } from '@/api/enterprise/enterprise'
export default {
  name: 'register-page',
  data() {
    return {
      fm: {},
      rules: {
        name: [
          { required: true, message: '请输入企业名称', trigger: 'blur' }
        ],
        industry: [
          { type: 'string', required: true, message: '请选择所属行业', trigger: 'change' }
        ],
        scale: [
          { type: 'string', required: true, message: '请选择企业规模', trigger: 'change' }
        ],
        phone: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          { required: true, message: '请输入正确的电话号码', trigger: 'blur',pattern:/^1(3|4|5|7|8|9|6)\d{9}$/ },
        ],
        address: [
          { required: true, message: '请输入公司地址', trigger: 'blur' }
        ]
      }, // 表单校验
      industry_list: [
        {
          name: '互联网/信息技术',
          id: 1
        },
        {
          name: '制造业',
          id: 2
        },
        {
          name: '贸易/批发/零售',
          id: 3
        },
        {
          name: '房地产业',
          id: 4
        },
        {
          name: '建筑业',
          id: 5
        },
        {
          name: '金融业',
          id: 6
        },
        {
          name: '服务业',
          id: 7
        },
        {
          name: '运输/物流/仓储',
          id: 8
        },
        {
          name: '教育行业',
          id: 9
        },
        {
          name: '文体/娱乐/传媒',
          id: 10
        },
        {
          name: '商业服务/租赁',
          id: 11
        },
        {
          name: '医疗医药',
          id: 12
        },
        {
          name: '政府/事业单位',
          id: 13
        },
        {
          name: '社会组织',
          id: 14
        },
        {
          name: '科研服务',
          id: 15
        },
        {
          name: '公共/环境',
          id: 16
        },
        {
          name: '居民服务',
          id: 17
        },
        {
          name: '开采业',
          id: 18
        },
        {
          name: '农/林/牧/渔',
          id: 19
        },
        {
          name: '电/热/燃气/水供应',
          id: 20
        },
        {
          name: '其他',
          id: 21
        }
      ], // 行业列表
      scale_list: [
        {
          name: '1-50人',
          id: 1
        },
        {
          name: '51-100人',
          id: 2
        },
        {
          name: '101-200人',
          id: 3
        },
        {
          name: '201-300人',
          id: 4
        },
        {
          name: '300人以上',
          id: 5
        }
      ],
    }
  },
  methods: {
    doRegister(){
      this.$refs['registerFm'].validate((valid) => {
        if (valid) {
          let info = this.fm
          if (!(/^1[3456789]\d{9}$/.test(info.phone))) {
            this.$message.warning('请输入正确的手机号')
            return
          }
          create(info).then(res => {
            if (res.data.code === 200) {
              console.log('申请成功，请等待管理人员审核',res)
              this.$message.success('申请成功，请等待管理人员审核！')
              this.$router.push({path:'/join/company'})
            } else {
              this.$message.error(res.data.message)
            }
          })
        }
      })
    },
    doBack(){
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="scss">
.new-nnterprise-page {
  height: 100vh;
  width: 100%;
  font-family:-apple-system,Noto Sans,Helvetica Neue,Helvetica,Nimbus Sans L,Arial,Liberation Sans,PingFang SC,Hiragino Sans GB,Noto Sans CJK SC,Source Han Sans SC,Source Han Sans CN,Microsoft YaHei,Wenquanyi Micro Hei,WenQuanYi Zen Hei,ST Heiti,SimHei,WenQuanYi Zen Hei Sharp,sans-serif;

  .toolbar {
    margin-top: 30px;
    display: flex;
    justify-content: space-between;
    padding: 0 50px;

    .btn {
      color: #595959;
      background: #e5e5e5;
      border: none;

      &:hover {
        border: none;
        color: #262626;
        background: #d9d9d9;
      }
    }
  }

  .content{
    background-color: #fff;
    width:500px;
    margin: 50px auto 20px;
    min-height: 460px;
    border:1px solid #ccc;
    border-radius: 6px;

    .home-title{
      font-size: 36px;
      font-weight: 400;
      margin:10px 0;
    }

    .home-description{
      margin:10px 0 10px;
      line-height: 24px;
      height: 24px;
      font-size: 18px;
      color: #8c8c8c;
      box-sizing: border-box;
      text-rendering: optimizeLegibility;
      font-weight: lighter;
    }

    hr{
      border: solid #e5e5e5;
      border-width: 1px 0 0 0;
      margin-bottom:24px;
      background: #f0f0f0;
    }

  }

  .btn-register{
    width:260px;
  }
}
</style>
